import { get, post } from '@/services/http';
import { MetricModel } from '@/models/metric';
import List from './list';

export class MetricList extends List<MetricModel> {

}
